<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-container modal-sm">
        <div class="modal-body text-center">
          <p class="lead">Loading
            <i class="fa fa-circle-o-notch fa-spin fa-lg fa-fw" aria-hidden="true"></i></p>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  export default {
    props: {
    },
    computed: {
    },
    methods: {
    }
  }
</script>
<style scoped>
  .modal-container, .modal-body {
    color: #fff;
    background: transparent;
    box-shadow: none;
  }
</style>



// WEBPACK FOOTER //
// LoadingModal.vue?beaf3e16